var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 10.6666H28.7201C28.2546 9.43314 27.5314 8.31312 26.5987 7.38128L21.9534 2.73328C21.0205 1.8017 19.9002 1.07906 18.6667 0.613281V9.33328C18.6667 9.6869 18.8072 10.026 19.0573 10.2761C19.3073 10.5261 19.6465 10.6666 20.0001 10.6666Z",
    fill: "#F1DABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3014 13.3333H20.0001C18.9392 13.3333 17.9218 12.9119 17.1717 12.1618C16.4215 11.4116 16.0001 10.3942 16.0001 9.33333V0.032C15.7854 0.0173333 15.5707 0 15.3534 0H9.33342C7.56595 0.00211714 5.87149 0.705176 4.62171 1.95496C3.37192 3.20474 2.66887 4.89921 2.66675 6.66667V25.3333C2.66887 27.1008 3.37192 28.7953 4.62171 30.045C5.87149 31.2948 7.56595 31.9979 9.33342 32H22.6667C24.4342 31.9979 26.1287 31.2948 27.3785 30.045C28.6282 28.7953 29.3313 27.1008 29.3334 25.3333V13.98C29.3334 13.7627 29.3161 13.548 29.3014 13.3333Z",
    fill: "#F1DABF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.8398835317d4c170aa8fa5aba51fd2e6.svg";
export { ForwardRef as ReactComponent };